import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import CButton from "../../buttons/CButton";

const CDeleteModel = ({
  show,
  setShow,
  action,
  text = "Are you sure you want to delete?",
}) => {
  const [loading, setLoading] = useState(false);

  const handleAction = async () => {
    try {
      setLoading(true);
      await action();
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      backdrop={loading ? "static" : true}
      keyboard={!loading}
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title id="example-custom-modal-styling-title">
          Delete
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="text-center">{text}</p>

        <Row>
          <Col className="text-center">
            <CButton
              name={loading ? "Deleting..." : "Yes"}
              variant="primary"
              action={handleAction}
            />

            <CButton name="No" variant="danger" action={handleClose} />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default CDeleteModel;
